// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".catalogSubsetBannerSmall[data-v-2803764a]{align-items:center;border:1px solid #e6e6e6;border-radius:4px;display:flex;margin-top:2rem;padding:1.5rem}.catalogSubsetBannerSmall__text[data-v-2803764a]{color:#343742;font-size:1.4rem;font-weight:600;line-height:1.28;padding-left:1.5rem}.catalogSubsetBannerSmall__text[data-v-2803764a] .iconLink{display:inline-flex}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
